module.exports = __webpack_public_path__ + "static/media/leaderboard-teams.59d1ab07.svg";